import React from 'react';
import { Box } from '@mui/material';

const StagingBanner = () => {
  // Función para detectar si estamos en staging basado en la URL
  const isStaging = () => {
    return window.location.hostname.includes('staging') || 
           window.location.href.includes('staging');
  };

  if (!isStaging()) return null;

  return (
    <Box
      sx={{
        bgcolor: '#ffeb3b',
        color: '#000000',
        p: 1,
        textAlign: 'center',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        fontWeight: 'bold',
        width: '100%',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        fontSize: '0.9rem'
      }}
    >
      Ambiente de Staging
    </Box>
  );
};

export default StagingBanner; 